// Configuration SEO centralisée pour toutes les langues
export const SEO_CONFIG = {
  defaultLanguage: 'fr',
  supportedLanguages: ['fr', 'en', 'es'],
  site: {
    name: {
      fr: 'RankServeur',
      en: 'RankServeur',
      es: 'RankServeur'
    },
    description: {
      fr: 'Découvrez et votez pour les meilleurs serveurs de jeux en ligne. Classement en temps réel, communauté active et serveurs vérifiés pour Minecraft, Dofus, WoW, CS2 et bien plus !',
      en: 'Discover and vote for the best online game servers. Real-time rankings, active community and verified servers for Minecraft, Dofus, WoW, CS2 and more!',
      es: 'Descubre y vota por los mejores servidores de juegos online. Rankings en tiempo real, comunidad activa y servidores verificados para Minecraft, Dofus, WoW, CS2 ¡y más!'
    },
    keywords: {
      fr: 'serveurs de jeux, classement serveurs, vote serveur, serveur minecraft, serveur dofus, serveur wow, serveur cs2, serveur gta rp, serveur rust, communauté gaming française, meilleurs serveurs privés, top serveurs français',
      en: 'game servers, server ranking, server voting, minecraft server, dofus server, wow server, cs2 server, gta rp server, rust server, gaming community, best private servers, top english servers',
      es: 'servidores de juegos, ranking servidores, votar servidor, servidor minecraft, servidor dofus, servidor wow, servidor cs2, servidor gta rp, servidor rust, comunidad gaming española, mejores servidores privados, top servidores españoles'
    },
    baseUrl: 'https://rankserveur.com',
    twitterHandle: '@rankserveur_official',
    ogImage: 'https://rankserveur.com/assets/logo.png',
    logo: 'https://rankserveur.com/assets/logo.png'
  },
  games: {
    minecraft: {
      fr: {
        title: 'Serveurs Privés Minecraft ▶ Top Classement | +1000 Serveurs',
        description: 'Top serveurs privés Minecraft français : Survival, Creative, PvP, Mini-jeux, Moddés. 1000+ serveurs actifs, classement temps réel, vote quotidien.',
        keywords: 'serveur privé minecraft, top serveur minecraft français, serveur minecraft gratuit, classement minecraft, survival minecraft, minecraft pvp, serveur minecraft moddé'
      },
      en: {
        title: 'Minecraft Private Servers ▶ Top Rankings | +1000 Servers',
        description: 'Top English Minecraft private servers: Survival, Creative, PvP, Mini-games, Modded. 1000+ active servers, real-time rankings, daily voting.',
        keywords: 'minecraft private server, top minecraft server, minecraft server list, best minecraft servers, minecraft survival, minecraft pvp, modded minecraft'
      },
      es: {
        title: 'Servidores Privados Minecraft ▶ Top Rankings',
        description: 'Top servidores privados Minecraft en español: Survival, Creative, PvP, Mini-juegos, Modded. 1000+ servidores activos, rankings en tiempo real.',
        keywords: 'servidor privado minecraft, top servidor minecraft, servidor minecraft gratis, ranking minecraft, survival minecraft, minecraft pvp, modded minecraft'
      }
    },
    dofus: {
      fr: {
        title: 'Serveurs Privés Dofus ▶ Retro, 1.29, 2.0+ | Top Classement',
        description: 'Top serveurs privés Dofus : Retro, 1.29, 2.70+. Rates personnalisés, communauté française active, économie équilibrée, événements exclusifs.',
        keywords: 'serveur privé dofus, top serveur dofus français, dofus private server, serveur dofus retro, serveur dofus 1.29, serveur dofus 2.0, classement dofus'
      },
      en: {
        title: 'Dofus Private Servers ▶ Retro, 1.29, 2.0+ | Top Rankings',
        description: 'Top English Dofus private servers: Retro, 1.29, 2.70+. Custom rates, active community, balanced economy, exclusive events. Vote and join!',
        keywords: 'dofus private server, top dofus server, dofus retro server, dofus 1.29 server, dofus 2.0 server, best dofus servers, dofus server list'
      },
      es: {
        title: 'Servidores Privados Dofus ▶ Retro, 1.29, 2.0+',
        description: 'Top servidores privados Dofus en español: Retro, 1.29, 2.70+. Rates personalizados, comunidad activa, economía equilibrada, eventos exclusivos.',
        keywords: 'servidor privado dofus, top servidor dofus, servidor dofus retro, servidor dofus 1.29, servidor dofus 2.0, dofus español, lista servidor dofus'
      }
    },
    wow: {
      fr: {
        title: 'Top Serveurs Privé WoW ▶ Classic, TBC, WotLK, Legion+',
        description: 'Top serveurs WoW privés français : Classic, TBC, WotLK, Legion, BFA, Shadowlands. Population active, scripts customs, GMs dédiés.',
        keywords: 'serveur privé wow, top serveur wow français, wow private server, serveur wow classic, serveur wow tbc, serveur wow wotlk, serveur wow legion'
      },
      en: {
        title: 'Top WoW Private Servers ▶ Classic, TBC, WotLK, Legion+',
        description: 'Best WoW private servers: Classic, TBC, WotLK, Legion, BFA, Shadowlands. High population, custom scripts, dedicated GMs.',
        keywords: 'wow private server, top wow server, wow classic server, wow tbc server, wow wotlk server, wow legion server, best wow servers'
      },
      es: {
        title: 'Top Servidores WoW Privados ▶ Classic, TBC, WotLK+',
        description: 'Top servidores WoW privados en español: Classic, TBC, WotLK, Legion, BFA, Shadowlands. Alta población, scripts customs, GMs dedicados.',
        keywords: 'servidor privado wow español, top servidor wow, servidor wow classic, servidor wow tbc, servidor wow wotlk, wow español'
      }
    },
    cs2: {
      fr: {
        title: 'Top Serveurs CS2 France ▶ Community Servers | RankServeur',
        description: 'Top serveurs Counter-Strike 2 français : Deathmatch, Surf, Retake, Aim, 1v1, Jail. Communauté CS2 active, ping optimal, anti-cheat.',
        keywords: 'serveur cs2 français, counter-strike 2 server france, serveur cs2 deathmatch, serveur cs2 surf, serveur cs2 retake, cs2 community server'
      },
      en: {
        title: 'Top CS2 Servers ▶ Community Servers | RankServeur',
        description: 'Best Counter-Strike 2 community servers: Deathmatch, Surf, Retake, Aim, 1v1, Jail. Active CS2 community, low ping, anti-cheat.',
        keywords: 'cs2 server, counter-strike 2 server, cs2 community server, cs2 deathmatch, cs2 surf, cs2 retake, best cs2 servers'
      },
      es: {
        title: 'Top Servidores CS2 España ▶ Community Servers',
        description: 'Mejores servidores Counter-Strike 2 en español: Deathmatch, Surf, Retake, Aim, 1v1, Jail. Comunidad CS2 activa, ping bajo, anti-cheat.',
        keywords: 'servidor cs2 español, counter-strike 2 server españa, servidor cs2 deathmatch, servidor cs2 surf, cs2 community server español'
      }
    },
    'gta-rp': {
      fr: {
        title: 'Top Serveurs GTA RP FiveM ▶ Roleplay Français',
        description: 'Top serveurs GTA RP FiveM français : roleplay immersif, économie réaliste, jobs variés, mapping custom. Rejoignez la communauté RP française.',
        keywords: 'serveur gta rp français, gta roleplay fivem, serveur fivem français, gta rp france, fivem server français, serveur rp gta'
      },
      en: {
        title: 'Top GTA RP FiveM Servers ▶ English Roleplay',
        description: 'Best English GTA RP FiveM servers: immersive roleplay, realistic economy, varied jobs, custom mapping. Join the English RP community.',
        keywords: 'gta rp server english, gta roleplay fivem, fivem server english, gta v rp server, fivem roleplay, best gta rp servers'
      },
      es: {
        title: 'Top Servidores GTA RP FiveM ▶ Roleplay Español',
        description: 'Mejores servidores GTA RP FiveM en español: roleplay inmersivo, economía realista, trabajos variados, mapping custom.',
        keywords: 'servidor gta rp español, gta roleplay fivem, servidor fivem español, gta rp españa, fivem server español'
      }
    },
    rust: {
      fr: {
        title: 'Top Serveurs Rust France ▶ PvP, PvE, Vanilla, Modded',
        description: 'Top serveurs Rust français : PvP hardcore, PvE chill, Vanilla, Modded, x2/x3 rates. Wipes réguliers, communauté active, anti-cheat.',
        keywords: 'serveur rust français, rust private server france, serveur rust pvp, serveur rust pve, serveur rust vanilla, serveur rust modded'
      },
      en: {
        title: 'Top Rust Private Servers ▶ PvP, PvE, Vanilla, Modded',
        description: 'Best English Rust servers: hardcore PvP, chill PvE, Vanilla, Modded, x2/x3 rates. Regular wipes, active community, anti-cheat.',
        keywords: 'rust server english, rust private server, rust pvp server, rust pve server, rust vanilla server, rust modded server'
      },
      es: {
        title: 'Top Servidores Rust España ▶ PvP, PvE, Vanilla, Modded',
        description: 'Mejores servidores Rust en español: PvP hardcore, PvE relajado, Vanilla, Modded, rates x2/x3. Wipes regulares, comunidad activa.',
        keywords: 'servidor rust español, rust private server españa, servidor rust pvp, servidor rust pve, servidor rust vanilla'
      }
    },
    'garry-mod': {
      fr: {
        title: "Top Serveurs Garry's Mod ▶ DarkRP, TTT, Sandbox",
        description: "Top serveurs Garry's Mod français : DarkRP, TTT, Sandbox, Roleplay, Jailbreak. Mods custom, communauté française active, addons exclusifs.",
        keywords: "serveur gmod français, garrys mod server france, serveur darkrp français, serveur gmod ttt, serveur gmod sandbox, darkrp français"
      },
      en: {
        title: "Top Garry's Mod Servers ▶ DarkRP, TTT, Sandbox",
        description: "Best English Garry's Mod servers: DarkRP, TTT, Sandbox, Roleplay, Jailbreak. Custom mods, active community, exclusive addons.",
        keywords: "gmod server english, garrys mod server, darkrp server, gmod ttt server, gmod sandbox server, best gmod servers"
      },
      es: {
        title: "Top Servidores Garry's Mod ▶ DarkRP, TTT, Sandbox",
        description: "Mejores servidores Garry's Mod en español: DarkRP, TTT, Sandbox, Roleplay, Jailbreak. Mods custom, comunidad activa, addons exclusivos.",
        keywords: "servidor gmod español, garrys mod server españa, servidor darkrp español, servidor gmod ttt, gmod sandbox español"
      }
    },
    dayz: {
      fr: {
        title: 'Top Serveurs DayZ France ▶ Survival, PvP, Modded',
        description: 'Top serveurs DayZ français : survival hardcore, PvP intense, mods personnalisés, mapping étendu. Survivez à l\'apocalypse zombie.',
        keywords: 'serveur dayz français, dayz private server france, serveur dayz survival, serveur dayz pvp, serveur dayz modded, dayz france'
      },
      en: {
        title: 'Top DayZ Private Servers ▶ Survival, PvP, Modded',
        description: 'Best English DayZ servers: hardcore survival, intense PvP, custom mods, extended mapping. Survive the zombie apocalypse.',
        keywords: 'dayz server english, dayz private server, dayz survival server, dayz pvp server, dayz modded server, best dayz servers'
      },
      es: {
        title: 'Top Servidores DayZ España ▶ Survival, PvP, Modded',
        description: 'Mejores servidores DayZ en español: survival hardcore, PvP intenso, mods personalizados, mapping extendido. Sobrevive al apocalipsis.',
        keywords: 'servidor dayz español, dayz private server españa, servidor dayz survival, servidor dayz pvp, dayz modded español'
      }
    }
  },
  pages: {
    home: {
      fr: {
        title: 'Top Serveurs Privés 2026 — Vote & Classement Gaming',
        description: 'Le top des serveurs privés gaming : Minecraft, Dofus, WoW, GTA RP, Rust, BDO. Classement live, vote toutes les 2h, 100k+ joueurs actifs. Rejoins gratuitement !',
        keywords: 'serveur privé, serveurs privés gaming, top serveur, classement serveur, serveur de jeu, meilleurs serveurs privés, liste serveur, serveur minecraft privé, serveur dofus privé, serveur wow privé, serveur cs2 privé, serveur gta rp privé, serveur rust privé, communauté gaming française, serveur gaming français, plateforme serveur, top liste serveur'
      },
      en: {
        title: 'Top Private Game Servers 2026 — Vote & Ranking List',
        description: 'The top private game servers: Minecraft, Dofus, WoW, GTA RP, Rust, BDO. Live ranking, vote every 2h, 100k+ active players worldwide. Join for free!',
        keywords: 'private server, private gaming servers, top server, server ranking, game server, best private servers, server list, minecraft private server, dofus private server, wow private server, cs2 private server, gta rp private server, rust private server, gaming community, server platform'
      },
      es: {
        title: 'Top Servidores Privados 2026 — Vota y Ranking Gaming',
        description: 'El top de servidores privados gaming: Minecraft, Dofus, WoW, GTA RP, Rust, BDO. Ranking en vivo, vota cada 2h, 100k+ jugadores activos. ¡Únete gratis!',
        keywords: 'servidor privado, servidores privados gaming, top servidor, ranking servidor, servidor de juego, mejores servidores privados, lista servidor, servidor minecraft privado, servidor dofus privado, servidor wow privado, servidor cs2 privado, servidor gta rp privado, servidor rust privado, comunidad gaming'
      }

    },
    leaderboard: {
      fr: {
        title: 'Top Voteurs RankServeur ▶ Classement Joueurs',
        description: 'Découvrez les meilleurs voteurs de RankServeur ! Classement quotidien, hebdomadaire et mensuel. Gagnez des récompenses exclusives en votant !',
        keywords: 'top voteurs rankserveur, classement voteurs, meilleurs joueurs, récompenses vote, classement quotidien, classement mensuel'
      },
      en: {
        title: 'Top Voters RankServeur ▶ Best Players Rankings',
        description: 'Discover RankServeur\'s top voters! Daily, weekly and monthly rankings. Win exclusive rewards by voting!',
        keywords: 'top voters rankserveur, voters ranking, best players, vote rewards, daily ranking, monthly ranking'
      },
      es: {
        title: 'Top Votantes RankServeur ▶ Rankings de Jugadores',
        description: '¡Descubre los mejores votantes de RankServeur! Rankings diarios, semanales y mensuales. ¡Gana recompensas exclusivas votando!',
        keywords: 'top votantes rankserveur, ranking votantes, mejores jugadores, recompensas voto, ranking diario, ranking mensual'
      }
    },
    addServer: {
      fr: {
        title: 'Ajouter votre Serveur Privé ▶ Gratuit & Rapide',
        description: 'Ajoutez gratuitement votre serveur de jeu sur RankServeur ! Augmentez votre visibilité, gagnez des joueurs et boostez votre communauté.',
        keywords: 'ajouter serveur, promouvoir serveur, référencer serveur, visibilité serveur, gagner joueurs'
      },
      en: {
        title: 'Add Your Private Server ▶ Free & Fast | RankServeur',
        description: 'Add your game server to RankServeur for free! Increase visibility, gain players and boost your community.',
        keywords: 'add server, promote server, list server, server visibility, gain players'
      },
      es: {
        title: 'Agregar tu Servidor Privado ▶ Gratis & Rápido',
        description: '¡Agrega tu servidor de juego a RankServeur gratis! Aumenta la visibilidad, gana jugadores y potencia tu comunidad.',
        keywords: 'agregar servidor, promover servidor, listar servidor, visibilidad servidor, ganar jugadores'
      }
    }
  }
} as const;

// Types pour TypeScript
export type Language = 'fr' | 'en' | 'es';
export type GameKey = keyof typeof SEO_CONFIG.games;
export type PageKey = keyof typeof SEO_CONFIG.pages;

// Fonction utilitaire pour obtenir la configuration SEO
export const getSEOConfig = (
  type: 'game' | 'page',
  key: GameKey | PageKey,
  language: Language = 'fr'
) => {
  if (type === 'game') {
    return SEO_CONFIG.games[key as GameKey]?.[language];
  } else {
    return SEO_CONFIG.pages[key as PageKey]?.[language];
  }
};

/**
 * Normalise un path pour le SEO (fonction locale)
 */
const normalizePathForSEO = (path: string): string => {
  let normalized = path;
  normalized = normalized.replace(/\/+/g, '/');
  
  // Supprimer doubles préfixes langue
  const langPrefixPattern = /^\/(fr|en|es)(?:\/(fr|en|es))+/;
  const match = normalized.match(langPrefixPattern);
  if (match) {
    const langs = normalized.match(/^\/(fr|en|es)/g);
    if (langs && langs.length > 1) {
      const firstLang = langs[0];
      normalized = normalized.replace(langPrefixPattern, firstLang);
    }
  }
  
  // CRITIQUE : /games/ → /game/
  normalized = normalized.replace(/\/games\//g, '/game/');
  normalized = normalized.replace(/\/+/g, '/');
  
  if (normalized !== '/') {
    normalized = normalized.replace(/\/$/, '');
  }
  
  return normalized;
};

// Fonction pour générer l'URL canonique
export const getCanonicalUrl = (path: string, language: Language = 'fr') => {
  const baseUrl = SEO_CONFIG.site.baseUrl;
  const normalizedPath = normalizePathForSEO(path);
  
  if (language === 'fr') {
    return `${baseUrl}${normalizedPath}`;
  }
  return `${baseUrl}/${language}${normalizedPath}`;
};

// Fonction pour générer les URLs alternatives (hreflang)
export const getAlternateUrls = (path: string) => {
  const baseUrl = SEO_CONFIG.site.baseUrl;
  const normalizedPath = normalizePathForSEO(path);
  
  return SEO_CONFIG.supportedLanguages.map(lang => ({
    hreflang: lang === 'fr' ? 'fr' : lang,
    href: lang === 'fr' ? `${baseUrl}${normalizedPath}` : `${baseUrl}/${lang}${normalizedPath}`
  }));
};